import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';

const Component = lazy(() => import('components/field-description-widget-crop-input'));

// Using null fallback because this component is rendered with tag="tr" in the view,
// and a <div> fallback would be invalid inside a <tr> element.
const FieldDescriptionWidgetCropInput = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={null}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default FieldDescriptionWidgetCropInput;
